import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */
import { resolveAddress } from "../address/index.js";
import { Transaction } from "../transaction/index.js";
import { defineProperties, getBigInt, resolveProperties, assert, assertArgument } from "../utils/index.js";
import { copyRequest } from "./provider.js";
function checkProvider(signer, operation) {
  if (signer.provider) {
    return signer.provider;
  }
  assert(false, "missing provider", "UNSUPPORTED_OPERATION", {
    operation: operation
  });
}
function populate(_x, _x2) {
  return _populate.apply(this, arguments);
}
/**
 *  An **AbstractSigner** includes most of teh functionality required
 *  to get a [[Signer]] working as expected, but requires a few
 *  Signer-specific methods be overridden.
 *
 */
function _populate() {
  _populate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(signer, tx) {
    var pop, from;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          pop = copyRequest(tx);
          if (pop.to != null) {
            pop.to = resolveAddress(pop.to, signer);
          }
          if (pop.from != null) {
            from = pop.from;
            pop.from = Promise.all([signer.getAddress(), resolveAddress(from, signer)]).then(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                address = _ref2[0],
                from = _ref2[1];
              assertArgument(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
              return address;
            });
          } else {
            pop.from = signer.getAddress();
          }
          _context12.next = 5;
          return resolveProperties(pop);
        case 5:
          return _context12.abrupt("return", _context12.sent);
        case 6:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _populate.apply(this, arguments);
}
export var AbstractSigner = /*#__PURE__*/function () {
  /**
   *  The provider this signer is connected to.
   */

  /**
   *  Creates a new Signer connected to %%provider%%.
   */
  function AbstractSigner(provider) {
    _classCallCheck(this, AbstractSigner);
    _defineProperty(this, "provider", void 0);
    defineProperties(this, {
      provider: provider || null
    });
  }
  _createClass(AbstractSigner, [{
    key: "getNonce",
    value: function () {
      var _getNonce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blockTag) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = checkProvider(this, "getTransactionCount");
              _context.next = 3;
              return this.getAddress();
            case 3:
              _context.t1 = _context.sent;
              _context.t2 = blockTag;
              return _context.abrupt("return", _context.t0.getTransactionCount.call(_context.t0, _context.t1, _context.t2));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getNonce(_x3) {
        return _getNonce.apply(this, arguments);
      }
      return getNonce;
    }()
  }, {
    key: "populateCall",
    value: function () {
      var _populateCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tx) {
        var pop;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return populate(this, tx);
            case 2:
              pop = _context2.sent;
              return _context2.abrupt("return", pop);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function populateCall(_x4) {
        return _populateCall.apply(this, arguments);
      }
      return populateCall;
    }()
  }, {
    key: "populateTransaction",
    value: function () {
      var _populateTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(tx) {
        var provider, pop, network, chainId, hasEip1559, feeData, _feeData, gasPrice;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              provider = checkProvider(this, "populateTransaction");
              _context3.next = 3;
              return populate(this, tx);
            case 3:
              pop = _context3.sent;
              if (!(pop.nonce == null)) {
                _context3.next = 8;
                break;
              }
              _context3.next = 7;
              return this.getNonce("pending");
            case 7:
              pop.nonce = _context3.sent;
            case 8:
              if (!(pop.gasLimit == null)) {
                _context3.next = 12;
                break;
              }
              _context3.next = 11;
              return this.estimateGas(pop);
            case 11:
              pop.gasLimit = _context3.sent;
            case 12:
              _context3.next = 14;
              return this.provider.getNetwork();
            case 14:
              network = _context3.sent;
              if (pop.chainId != null) {
                chainId = getBigInt(pop.chainId);
                assertArgument(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
              } else {
                pop.chainId = network.chainId;
              }
              // Do not allow mixing pre-eip-1559 and eip-1559 properties
              hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
              if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) {
                assertArgument(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
              } else if ((pop.type === 0 || pop.type === 1) && hasEip1559) {
                assertArgument(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
              }
              if (!((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null)) {
                _context3.next = 22;
                break;
              }
              // Fully-formed EIP-1559 transaction (skip getFeeData)
              pop.type = 2;
              _context3.next = 34;
              break;
            case 22:
              if (!(pop.type === 0 || pop.type === 1)) {
                _context3.next = 30;
                break;
              }
              _context3.next = 25;
              return provider.getFeeData();
            case 25:
              feeData = _context3.sent;
              assert(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
              });
              // Populate missing gasPrice
              if (pop.gasPrice == null) {
                pop.gasPrice = feeData.gasPrice;
              }
              _context3.next = 34;
              break;
            case 30:
              _context3.next = 32;
              return provider.getFeeData();
            case 32:
              _feeData = _context3.sent;
              if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (_feeData.maxFeePerGas != null && _feeData.maxPriorityFeePerGas != null) {
                  // The network supports EIP-1559!
                  // Upgrade transaction from null to eip-1559
                  pop.type = 2;
                  if (pop.gasPrice != null) {
                    // Using legacy gasPrice property on an eip-1559 network,
                    // so use gasPrice as both fee properties
                    gasPrice = pop.gasPrice;
                    delete pop.gasPrice;
                    pop.maxFeePerGas = gasPrice;
                    pop.maxPriorityFeePerGas = gasPrice;
                  } else {
                    // Populate missing fee data
                    if (pop.maxFeePerGas == null) {
                      pop.maxFeePerGas = _feeData.maxFeePerGas;
                    }
                    if (pop.maxPriorityFeePerGas == null) {
                      pop.maxPriorityFeePerGas = _feeData.maxPriorityFeePerGas;
                    }
                  }
                } else if (_feeData.gasPrice != null) {
                  // Network doesn't support EIP-1559...
                  // ...but they are trying to use EIP-1559 properties
                  assert(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                    operation: "populateTransaction"
                  });
                  // Populate missing fee data
                  if (pop.gasPrice == null) {
                    pop.gasPrice = _feeData.gasPrice;
                  }
                  // Explicitly set untyped transaction to legacy
                  // @TODO: Maybe this shold allow type 1?
                  pop.type = 0;
                } else {
                  // getFeeData has failed us.
                  assert(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                  });
                }
              } else if (pop.type === 2) {
                // Explicitly using EIP-1559
                // Populate missing fee data
                if (pop.maxFeePerGas == null) {
                  pop.maxFeePerGas = _feeData.maxFeePerGas;
                }
                if (pop.maxPriorityFeePerGas == null) {
                  pop.maxPriorityFeePerGas = _feeData.maxPriorityFeePerGas;
                }
              }
            case 34:
              _context3.next = 36;
              return resolveProperties(pop);
            case 36:
              return _context3.abrupt("return", _context3.sent);
            case 37:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function populateTransaction(_x5) {
        return _populateTransaction.apply(this, arguments);
      }
      return populateTransaction;
    }()
  }, {
    key: "estimateGas",
    value: function () {
      var _estimateGas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tx) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = checkProvider(this, "estimateGas");
              _context4.next = 3;
              return this.populateCall(tx);
            case 3:
              _context4.t1 = _context4.sent;
              return _context4.abrupt("return", _context4.t0.estimateGas.call(_context4.t0, _context4.t1));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function estimateGas(_x6) {
        return _estimateGas.apply(this, arguments);
      }
      return estimateGas;
    }()
  }, {
    key: "call",
    value: function () {
      var _call = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(tx) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = checkProvider(this, "call");
              _context5.next = 3;
              return this.populateCall(tx);
            case 3:
              _context5.t1 = _context5.sent;
              return _context5.abrupt("return", _context5.t0.call.call(_context5.t0, _context5.t1));
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function call(_x7) {
        return _call.apply(this, arguments);
      }
      return call;
    }()
  }, {
    key: "resolveName",
    value: function () {
      var _resolveName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(name) {
        var provider;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              provider = checkProvider(this, "resolveName");
              _context6.next = 3;
              return provider.resolveName(name);
            case 3:
              return _context6.abrupt("return", _context6.sent);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function resolveName(_x8) {
        return _resolveName.apply(this, arguments);
      }
      return resolveName;
    }()
  }, {
    key: "sendTransaction",
    value: function () {
      var _sendTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(tx) {
        var provider, pop, txObj;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              provider = checkProvider(this, "sendTransaction");
              _context7.next = 3;
              return this.populateTransaction(tx);
            case 3:
              pop = _context7.sent;
              delete pop.from;
              txObj = Transaction.from(pop);
              _context7.t0 = provider;
              _context7.next = 9;
              return this.signTransaction(txObj);
            case 9:
              _context7.t1 = _context7.sent;
              _context7.next = 12;
              return _context7.t0.broadcastTransaction.call(_context7.t0, _context7.t1);
            case 12:
              return _context7.abrupt("return", _context7.sent);
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function sendTransaction(_x9) {
        return _sendTransaction.apply(this, arguments);
      }
      return sendTransaction;
    }()
  }]);
  return AbstractSigner;
}();
/**
 *  A **VoidSigner** is a class deisgned to allow an address to be used
 *  in any API which accepts a Signer, but for which there are no
 *  credentials available to perform any actual signing.
 *
 *  This for example allow impersonating an account for the purpose of
 *  static calls or estimating gas, but does not allow sending transactions.
 */
var _throwUnsupported = /*#__PURE__*/new WeakSet();
export var VoidSigner = /*#__PURE__*/function (_AbstractSigner) {
  _inherits(VoidSigner, _AbstractSigner);
  var _super = _createSuper(VoidSigner);
  /**
   *  The signer address.
   */

  /**
   *  Creates a new **VoidSigner** with %%address%% attached to
   *  %%provider%%.
   */
  function VoidSigner(address, provider) {
    var _this;
    _classCallCheck(this, VoidSigner);
    _this = _super.call(this, provider);
    _classPrivateMethodInitSpec(_assertThisInitialized(_this), _throwUnsupported);
    _defineProperty(_assertThisInitialized(_this), "address", void 0);
    defineProperties(_assertThisInitialized(_this), {
      address: address
    });
    return _this;
  }
  _createClass(VoidSigner, [{
    key: "getAddress",
    value: function () {
      var _getAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.address);
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getAddress() {
        return _getAddress.apply(this, arguments);
      }
      return getAddress;
    }()
  }, {
    key: "connect",
    value: function connect(provider) {
      return new VoidSigner(this.address, provider);
    }
  }, {
    key: "signTransaction",
    value: function () {
      var _signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(tx) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _classPrivateMethodGet(this, _throwUnsupported, _throwUnsupported2).call(this, "transactions", "signTransaction");
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function signTransaction(_x10) {
        return _signTransaction.apply(this, arguments);
      }
      return signTransaction;
    }()
  }, {
    key: "signMessage",
    value: function () {
      var _signMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(message) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _classPrivateMethodGet(this, _throwUnsupported, _throwUnsupported2).call(this, "messages", "signMessage");
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function signMessage(_x11) {
        return _signMessage.apply(this, arguments);
      }
      return signMessage;
    }()
  }, {
    key: "signTypedData",
    value: function () {
      var _signTypedData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(domain, types, value) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _classPrivateMethodGet(this, _throwUnsupported, _throwUnsupported2).call(this, "typed-data", "signTypedData");
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function signTypedData(_x12, _x13, _x14) {
        return _signTypedData.apply(this, arguments);
      }
      return signTypedData;
    }()
  }]);
  return VoidSigner;
}(AbstractSigner);
function _throwUnsupported2(suffix, operation) {
  assert(false, "VoidSigner cannot sign ".concat(suffix), "UNSUPPORTED_OPERATION", {
    operation: operation
  });
}